import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ChatTitle from '~/components/llm/chatTitle'
import { useLlmChatContext } from '~/components/llm/llmChatContext'
import MessageSkeleton from '~/components/llm/messageSkeleton'
import { toastInfo } from '~/components/toasts'
import styled from 'styled-components'

const MessagesArea = styled.div`
  flex: 1;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 800px;

  @media screen and (max-width: 1150px) {
    padding: 0px 10px;
  }
`

export default function GeneralLlmChatArchivedScreen() {
  const { isLoadingChatList, chatList } = useLlmChatContext()
  const navigate = useNavigate()
  const isAlreadyLoaded = useRef(false)
  const isReady = useRef(false)

  useEffect(() => {
    if (isLoadingChatList) {
      isAlreadyLoaded.current = true
    }

    if (isAlreadyLoaded.current && !isReady.current && !isLoadingChatList) {
      isReady.current = true
    }
  }, [isLoadingChatList, isAlreadyLoaded.current])

  useEffect(() => {
    if (!isReady.current) return

    if (chatList.length > 0) {
      navigate(`/app/ai/archived/${chatList[0]?.id}`)
    } else {
      toastInfo('Nenhum chat arquivado encontrado')
      navigate('/app/ai')
    }
  }, [chatList, navigate, isReady.current])

  return (
    <>
      <ChatTitle chatId={-1} isFixed={false} isArchived={false}>
        Carregando...
      </ChatTitle>
      <MessagesArea>
        <MessageSkeleton />
      </MessagesArea>
    </>
  )
}
